module.exports = __webpack_public_path__ + "img/Seccion1-Movil.970da967.png";